import React from "react";
import { useTranslation, Trans } from "react-i18next";
import { motion } from "motion/react";
import { transitionSoft, viewportOnce } from "../animations";

function Testimonial() {
  const { t } = useTranslation();
  return (
    <div className="relative w-full pb-10 md:pb-14">
      {/* Фон как на макете: сверху #f5f5f5 до середины блока, ниже — белый */}
      <div
        className="pointer-events-none absolute left-1/2 top-0 z-0 h-1/2 w-screen max-w-none -translate-x-1/2 bg-[#F5F5F5]"
        aria-hidden
      />
      <div
        className="pointer-events-none absolute bottom-0 left-1/2 z-0 h-1/2 w-screen max-w-none -translate-x-1/2 bg-white"
        aria-hidden
      />
      <motion.div
        className="relative z-10 m-auto -mt-4 flex flex-col-reverse place-items-center justify-between overflow-hidden rounded-[50px] bg-gradient-to-br from-[#b12a27] via-[#c8362f] to-[#6f1514] px-0 pt-[30px] shadow-[0_25px_60px_-12px_rgba(0,0,0,0.22)] md:-mt-8 md:flex-row md:pt-0 md:pr-[47px] lg:-mt-2 lg:max-w-[1024px] xl:h-[400px] xl:max-w-[1280px]"
        initial={{ opacity: 0, y: 36 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={viewportOnce}
        transition={{ ...transitionSoft, duration: 0.55 }}
      >
        <div
          className="pointer-events-none absolute inset-0 opacity-70"
          style={{
            background:
              "radial-gradient(900px 420px at 18% 20%, rgba(255,255,255,0.18) 0%, rgba(255,255,255,0) 55%), radial-gradient(700px 420px at 88% 72%, rgba(0,0,0,0.22) 0%, rgba(0,0,0,0) 60%)",
          }}
          aria-hidden
        />
        <motion.div
          className="relative"
          initial={{ opacity: 0, scale: 0.98 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ ...transitionSoft, delay: 0.1 }}
        >
          <img
            src="/img/hend2.png"
            onError={(e) => {
              e.currentTarget.onerror = null;
              e.currentTarget.src = "/img/lining.svg";
            }}
            className="rounded-[50px] bg-white/10 object-cover shadow-[0_18px_45px_-18px_rgba(0,0,0,0.55)] xl:w-[644px]"
            alt="ICB Mobile"
          />
        </motion.div>
        <div className="relative px-[16px] text-white md:w-[550px] md:px-[0] md:space-y-[8px] lg:space-y-[28px] xl:space-y-[32px]">
          <motion.p
            className="text-justify text-[16px] font-normal leading-[25px] text-white/95 lg:text-[18px] xl:text-[21px]"
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ ...transitionSoft, delay: 0.12 }}
          >
            <Trans
              i18nKey="testimonial.p1"
              components={{
                bold: (
                  <b className="font-semibold text-white text-[16px] lg:text-[18px] xl:text-[21px]" />
                ),
              }}
            />
          </motion.p>
          <motion.p
            className="text-justify text-[16px] font-normal leading-[25px] text-white/90 lg:text-[18px] xl:text-[21px]"
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ ...transitionSoft, delay: 0.2 }}
          >
            {t("testimonial.p2")}
          </motion.p>
        </div>
      </motion.div>
    </div>
  );
}
export default Testimonial;
